import log from '../../../commons/systemCommon/log.js';
import mqManager from './mqManager.js';
import common from './common.js';
import util from '../../../commons/util.js';
export default {
    /**
     * @func  initMqInfo
     * @desc  初始化MQ信息
     * @param {object} mqObject  mq对象结构体
     * @return {object} returnInfo
     */
    initMQInfo(mqObject) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (!util.isEmpty(mqObject)) {
            returnInfo = mqManager.initMQInfo(mqObject);
        }
        return returnInfo;
    },
    /**
     * @func   cleanMQInfo
     * @desc  清空MQ信息
     * @return {boolean} 是否存在
     */
    cleanMQInfo() {
        mqManager.cleanMQInfo();
    },
    /**
     * @func  removeMqInfoById
     * @desc  根据MqId删除MQ信息
     * @param {string} mqId  消息中间件id
     * @return {boolean} 是否成功
     */
    removeMqInfoById(mqId) {
        if (!util.isEmpty(mqId)) {
            mqManager.removeMqInfoById(mqId);
            return true;
        }
        return false;
    },
    /**
     * @func  initChannelInfo
     * @desc  初始化通道信息
     * @param {object} channelObject  通道信息
     * @return {object} returnInfo
     */
    initChannelInfo(channelObject) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (!util.isEmpty(channelObject)) {
            returnInfo = mqManager.initChannelInfo(channelObject);
        }
        return returnInfo;
    },
    /**
     * @func   cleanChannelInfo
     * @desc  清空通道信息
     * @return {object} null
     */
    cleanChannelInfo() {
        mqManager.cleanChannelInfo();
    },
    /**
     * @func  removeChannelInfoById
     * @desc  根据通道Id删除通道信息
     * @param {string} channelId  通道id
     * @return {boolean} 是否成功
     */
    removeChannelInfoById(channelId) {
        if (!util.isEmpty(channelId)) {
            mqManager.removeChannelInfoById(channelId);
            return true;
        }
        return false;
    },
    /**
     * @func  connectMq
     * @desc  创建MQ连接
     * @param {string} mqId  消息中间件id
     * @return {boolean} 是否成功
     */
    connectMq(mqId) {
        if (!util.isEmpty(mqId)) {
            return mqManager.connectMq(mqId);
        }
        log.error(common.logInfo.MQ_UTILS + common.logInfo.CONNECTMQ + window.vue.$t('returnInfo.PARAMETER_ERROR'));
        return false;
    },
    /**
     * @func  sendMsg
     * @desc  发送信息
     * @param {string} channelId  通道id
     * @param {jsonString} msg  消息JSON串
     * @return {boolean} 是否成功
     */
    sendMsg(channelId, msg) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (!util.isEmpty(channelId)) {
            returnInfo = mqManager.sendMsg(channelId, null, msg);
        } else {
            log.error(common.logInfo.MQ_UTILS + common.logInfo.SENDMSG + window.vue.$t('returnInfo.PARAMETER_ERROR'));
        }
        return returnInfo;
    },
    /**
     * @func  sendMsgByRoutingKey
     * @desc  发送信息
     * @param {string} channelId  通道id
     * @param {string} routingKeys  路由键 可以为空字符串
     * @param {jsonString} msg  消息JSON串
     * @return {boolean} 是否成功
     */
    sendMsgByRoutingKey(channelId, routingKeys, msg) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (!util.isEmpty(channelId) && routingKeys != null) {
            returnInfo = mqManager.sendMsg(channelId, routingKeys, msg);
        } else {
            log.error(common.logInfo.MQ_UTILS + common.logInfo.SENDMSG + window.vue.$t('returnInfo.PARAMETER_ERROR'));
        }
        return returnInfo;
    },
    /**
     * @func  receiveMsg
     * @desc  接受消息
     * @param {string} channelId  通道id
     * @param {function} reciveCallback  回调函数
     * @param {string} subscribeId  订阅id 可选参数
     * @return {function}  reciveCallback 回调函数
     */
    receiveMsg(channelId, reciveCallback, subscribeId) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (!util.isEmpty(channelId)) {
            returnInfo = mqManager.receiveMsg(channelId, null, reciveCallback, subscribeId);
        } else {
            log.error(common.logInfo.MQ_UTILS + common.logInfo.RECEIVEMSG + window.vue.$t('returnInfo.PARAMETER_ERROR'));
        }
        return returnInfo;
    },
    /**
     * @func  receiveMsgByRoutingKey
     * @desc  接受消息
     * @param {string} channelId  通道id
     * @param {string} routingKeys  路由键 可以为空字符串
     * @param {function} reciveCallback  回调函数
     * @param {string} subscribeId  订阅id 可选参数
     * @return {function}  reciveCallback 回调函数
     */
    receiveMsgByRoutingKey(channelId, routingKeys, reciveCallback, subscribeId) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (!util.isEmpty(channelId) && routingKeys != null) {
            returnInfo = mqManager.receiveMsg(channelId, routingKeys, reciveCallback, subscribeId);
        } else {
            log.error(common.logInfo.MQ_UTILS + common.logInfo.RECEIVEMSG + window.vue.$t('returnInfo.PARAMETER_ERROR'));
        }
        return returnInfo;
    },
    /**
     * @func  unSubscribeMsg
     * @desc  取消订阅消息
     * @param {string} subscribeId  订阅id
     * @return {object}  returnInfo
     */
    unSubscribeMsg(subscribeId, routingKeys) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (!util.isEmpty(subscribeId)) {
            returnInfo = mqManager.unSubscribeMsg(subscribeId, routingKeys);
        } else {
            log.error(common.logInfo.MQ_UTILS + common.logInfo.UNSUBSRCIBEMSG + window.vue.$t('returnInfo.PARAMETER_ERROR'));
        }
        return returnInfo;
    },
    /**
     * @func  disconnectMq
     * @desc  根据mqId断开MQ连接
     * @param {string} mqId 消息中间件id
     * @return {boolean} 是否成功
     */
    disconnectMq() {
        mqManager.disconnectMq();
    }
};
